import { z } from 'zod';
import { isoDateStringSchema, uuidSchema } from '@mrrmlab/shared-types';
import type { HttpClient } from './http';

const candidateLifecycleStateSchema = z.enum(['pending', 'planned', 'done', 'obsolete']);
const candidatePrioritySchema = z.enum(['low', 'normal', 'high']);
const candidateSourceSchema = z.enum(['mail', 'tracking', 'calendar', 'habit', 'project', 'manual', 'todo']);

export const markDoneResponseSchema = z.object({
  id: uuidSchema,
  lifecycleState: candidateLifecycleStateSchema,
  updatedAt: isoDateStringSchema,
});
export type MarkDoneResponse = z.infer<typeof markDoneResponseSchema>;

export const trackingCandidateSchema = z.object({
  id: uuidSchema,
  source: candidateSourceSchema,
  title: z.string(),
  priority: candidatePrioritySchema,
  lifecycleState: candidateLifecycleStateSchema,
  createdAt: isoDateStringSchema,
});
export type TrackingCandidate = z.infer<typeof trackingCandidateSchema>;

export class CandidatesResource {
  constructor(private readonly http: HttpClient) {}

  listByTracking(trackingId: string, signal?: AbortSignal): Promise<TrackingCandidate[]> {
    return this.http.request({
      method: 'GET',
      path: `/candidates?trackingId=${encodeURIComponent(trackingId)}`,
      responseSchema: z.array(trackingCandidateSchema),
      signal,
    });
  }

  markDone(id: string, signal?: AbortSignal): Promise<MarkDoneResponse> {
    return this.http.request({
      method: 'POST',
      path: `/candidates/${id}/done`,
      responseSchema: markDoneResponseSchema,
      signal,
    });
  }
}
